<template>
  <div class="section section-tabs">
    <div class="container-fluid mb-3">
      <div class="title" style="text-align: center;">
        <h2 style="font-weight: 900; text-decoration: underline;">MARCAS</h2>
        <p class="category">TRABAJANDO CON LAS MARCAS MÁS RECONOCIDAS Y CONFIABLES</p>
      </div>
      <div class="row" style="text-align: center;">
        <div class="col-6 col-md-2 form-group mx-auto mb-5">
          <a href="https://new.abb.com/mx" target="_blank">
            <img src="@/assets/ABB.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
          </a>
        </div>
        <div class="col-6 col-md-2 form-group mx-auto mb-5">
          <a href="https://circutor.com/" target="_blank">
            <img src="@/assets/CIRCUTOR.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
          </a>
        </div>
        <div class="col-6 col-md-2 form-group mx-auto mb-5">
          <a href="https://www.rittal.com/es-es/" target="_blank">
            <img src="@/assets/RITTAL.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
          </a>
        </div>
        <div class="col-6 col-md-2 form-group mx-auto mb-5">
          <a href="https://www.cubic.eu/es/" target="_blank">
            <img src="@/assets/CUBIC.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
          </a>
        </div>
        <div class="col-6 col-md-2 form-group mx-auto mb-5">
          <a href="https://www.eaton.com/mx/es-mx.html" target="_blank">
            <img src="@/assets/EATON.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
          </a>
        </div>
        <div class="col-6 col-md-2 form-group mx-auto mb-5">
          <a href="https://www.xylem.com/es-mx/" target="_blank">
            <img src="@/assets/XYLEM.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
          </a>
        </div>
      </div>
      <div class="row" style="text-align: center;">
        <div class="col-6 col-md-2 form-group mx-auto mb-5">
          <a href="https://flowtronex.com/" target="_blank">
            <img src="@/assets/FLOWTRONEX.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
          </a>
        </div>
        <div class="col-6 col-md-2 form-group mx-auto mb-5">
          <a href="https://www.bohn.com.mx/" target="_blank">
            <img src="@/assets/BOHN.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
          </a>
        </div>
        <div class="col-6 col-md-2 form-group mx-auto mb-5">
          <a href="https://www.lennox-mexico.com/" target="_blank">
            <img src="@/assets/LENNOX.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
          </a>
        </div>
        <div class="col-6 col-md-2 form-group mx-auto mb-5">
          <a href="https://www.voltran.com.mx/" target="_blank">
            <img src="@/assets/VOLTRAN.png" width="100" height="100" class="mr-1" style="margin-top: -6px">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  }
};
</script>
<style>
.tab-content.tab-content-padding {
  padding: 20px;
}
</style>
